import type { Box } from '../strangler'

// The stale-by-one-tick platinum upgrade 6 multiplier (pristine: written
// script.js:1469-1471 at the END of updateSmall, consumed at :1322 at the
// START of the next). At bridge-install time the window still holds the
// #platinumUpgrade6Effect ELEMENT via named access, and Decimal.mul(element)
// is 0 — the bridge seeds from it so the locked one-tick-zero-after-load
// behavior survives promotion (test/tick-sim.test.js). Value is element then
// Decimal; typed opaquely until step 5.
export const platinumUpgrade6Effect: Box<unknown> = { value: undefined }
